/// <reference types="google-publisher-tag" />

'use client'

import AdSlot from '@/app/[locale]/(worlds)/[roomId]/components/AdSlot'
import { getRecommendationColumnAdSizes } from '@/constants/ad'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { usePlatformAdFree } from '@/hooks/usePlatformAdFree'
import { env } from '@/lib/runtime-env'
import { cn } from '@/lib/utils'

const AD_SIZE_300x250 = [300, 250] as googletag.SingleSizeArray
const AD_SIZE_336x280 = [336, 280] as googletag.SingleSizeArray
const AD_SIZE_320x50 = [320, 50] as googletag.SingleSizeArray
const AD_SIZE_320x100 = [320, 100] as googletag.SingleSizeArray
const AD_SIZE_1x1 = [1, 1] as googletag.SingleSizeArray

const MOBILE_GPT_AD_SIZES: googletag.MultiSize = [
  AD_SIZE_320x100,
  AD_SIZE_1x1,
  AD_SIZE_320x50,
  AD_SIZE_336x280,
  AD_SIZE_300x250,
]

type RecommendColumnAdSlotProps = {
  type: 'desktop' | 'mobile'
  className?: string
  recommendationWidth?: number
}

function RecommendColumnAdSlot({
  type,
  className,
  recommendationWidth = 0,
}: RecommendColumnAdSlotProps) {
  const { isAdFree } = usePlatformAdFree()
  const enableFull3d = useEnableFull3d()

  const adSizes =
    type === 'desktop' ? getRecommendationColumnAdSizes(recommendationWidth) : MOBILE_GPT_AD_SIZES

  const gamAdUnitPath =
    adSizes.length === 0
      ? undefined
      : type === 'mobile'
        ? env('NEXT_PUBLIC_GAM_MOBILE_AD_UNIT_PATH')
        : env('NEXT_PUBLIC_GAM_RECOMMENDATION_AD_UNIT_PATH')

  if (isAdFree || enableFull3d || !gamAdUnitPath) return null

  return (
    <AdSlot
      adSurface="recommend-column"
      gamAdUnitPath={gamAdUnitPath}
      sizes={adSizes}
      className={cn(
        'flex justify-center overflow-hidden',
        type === 'mobile' ? 'w-full px-4' : 'w-full',
        className,
      )}
      contentClassName="max-w-full"
    />
  )
}

export default RecommendColumnAdSlot
